import { render, staticRenderFns } from "./material_details_s.vue?vue&type=template&id=6bc63300&scoped=true&"
import script from "./material_details_s.vue?vue&type=script&lang=js&"
export * from "./material_details_s.vue?vue&type=script&lang=js&"
import style0 from "./material_details_s.vue?vue&type=style&index=0&id=6bc63300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc63300",
  null
  
)

export default component.exports